const headerContentEndpoint = '/ajax/film-page-header-content';
const headerContentCache = new Map();

// Fetches film header content for a given film ID.
// Note, the endpoint can accept multiple IDs at once (separated by |),
// but this function fetches content for a single film ID.
const fetchFilmHeaderContent = async function (filmId) {
  try {
    // This endpoint may be called from multiple components in the page.
    // Results are cached to avoid redundant network requests.
    const filmIdInt = parseInt(filmId, 10);
    if (!headerContentCache.has(filmIdInt)) {
      const response = await fetch(`${headerContentEndpoint}?ids=${filmId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const headerContent = await response.json();
      headerContentCache.set(filmIdInt, headerContent);
    }
    return headerContentCache.get(filmIdInt);
  } catch (error) {
    console.error('Error fetching film header content:', error);
    throw error;
  }
};

// Fetches film header content for a given film ID.
// Note, the endpoint can accept multiple IDs at once (separated by |),
// but this function fetches content for a single film ID.
const fetchFilmPrices = async function (filmIds) {
  // This endpoint may be called from multiple components in the page.
  // Results are cached to avoid redundant network requests.
  try {
    const filmPrices = new Map();
    let queryIds = [];
    const filmIdsInt = filmIds.map((filmId) => parseInt(filmId, 10));
    // Look for cached results and remove from the query.
    for (const filmId of filmIdsInt) {
      if (!headerContentCache.has(filmId)) {
        queryIds.push(filmId);
      }
    }
    // Query the API endpoint.
    if (queryIds.length > 0) {
      const response = await fetch(`${headerContentEndpoint}?ids=${queryIds.join('|')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Fill up the cache with the results.
      const headerContents = await response.json();
      for (const [filmId, headerContent] of Object.entries(headerContents)) {
        headerContentCache.set(parseInt(filmId, 10), headerContent);
      }

      // Read results from cache.
      for (const filmId of filmIdsInt) {
        const headerContent = headerContentCache.get(filmId);
        filmPrices.set(filmId, headerContent?.price.film_card_price);
      }
    }
    return filmPrices;
  } catch (error) {
    console.error('Error fetching film header content:', error);
    throw error;
  }
};

export default {
  fetchFilmHeaderContent,
  fetchFilmPrices,
};
